import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import Experience from "./Experience";
import * as THREE from 'three';

export default class Camera
{
    constructor()
    {
        //Setup
        this.experience = new Experience()
        this.canvas = this.experience.canvas
        this.scene = this.experience.scene
        this.sizes = this.experience.sizes
        this.debug = this.experience.debug

        this.setInstance()
        this.setOrbitControls()
        this.setDebug()
    }

    setInstance()
    {
        this.instance = new THREE.PerspectiveCamera(35, this.sizes.width / this.sizes.height, 0.1, 100)
        this.instance.position.set(-11, 15, 38)


        this.scene.add(this.instance)
    }

    setOrbitControls()
    {
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true
        this.controls.dampingFactor = 0.003;
        this.controls.minPolarAngle = Math.PI / 4;
        this.controls.maxPolarAngle = Math.PI / 2.2; 


        this.controls.target.x = 7; 

    }

    setDebug()
    {
        if(this.debug.active)
        {
            this.debugCameraFolder = this.debug.gui.addFolder('Camera')
            this.debugCameraFolder.add(this.instance.position, 'x').min(-50).max(50).step(0.001)
            this.debugCameraFolder.add(this.instance.position, 'y').min(-50).max(50).step(0.001)
            this.debugCameraFolder.add(this.instance.position, 'z').min(-50).max(50).step(0.001)

        }
    }

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update()
    {
        this.controls.update()
    }

}